var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChannel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.3636,
    height: 16.3636,
    rx: 2,
    fill: "#B1B1B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 19.6364,
    width: 16.3636,
    height: 16.3636,
    rx: 2,
    fill: "#B1B1B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6365,
    width: 16.3636,
    height: 16.3636,
    rx: 2,
    fill: "#B1B1B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6365,
    y: 19.6364,
    width: 16.3636,
    height: 16.3636,
    rx: 2,
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChannel4);
export default __webpack_public_path__ + "static/media/ico-channel-4.1a2854f72baae6af8b5b3a645d81e8a5.svg";
export { ForwardRef as ReactComponent };